<img class="avatar image-avatar" *ngIf="model.avatar$()"
     [src]="model.avatar$()"
     [tooltipEnable]="model.enableTooltip$()"
     data-container="body"
     [height] = "model.size$()"
     [width] = "model.size$()"
     [tooltip]="model.firstName$() + ' ' + model.lastName$()" />

<div #initialsAvatar *ngIf="!model.avatar$()"
     [class]="'avatar initials-avatar initials-avatar-' + model.userType$()">
      <span #initialsAvatarString
            class="initials-avatar-string"
            [tooltipEnable]="model.enableTooltip$()"
            data-container="body"
            [tooltip]="model.firstName$() + ' ' + model.lastName$()">{{model.userInitials$()}}
      </span>
</div>
